<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col>
        <b-card title="Live" bg-variant="secondary">
          <label>Rechercher</label>
          <b-input @change="load(true)" v-model="search"></b-input>
          <b-row>
            <b-col lg="2">
              <b-card class="mt-3 shadow bg-light"  v-if="loaded">
                <b-card-title><h6>Négotiateurs</h6></b-card-title>
                <b-nav vertical>
                  <b-nav-item :class="selectedUser == null ? 'bg-info' : ''" @click="clickUser(null)">Tous les négos</b-nav-item>
                  <b-nav-item v-for="(user,i) in users" :key="i" :class="selectedUser == user.ID ? 'bg-info' : ''" @click="clickUser(user.ID)">
                    {{ user.login }}
                  </b-nav-item>
                </b-nav>
              </b-card>
            </b-col>
            <b-col lg="10">
              <template v-if="loaded">
                <div v-html="this.history"></div>
              </template>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import gestions from "@/services/gestion.js";
import DateTime from "@/services/DateTime.js";
export default {
  name: "Live",
  data() {
    return {
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Live",
          active: true,
        },
      ],
      loaded: false,
      users: [],
      search: "",
      selectedUser: null,
      history: [],
      busy: false,
      myInterval: null,
      DateTime,
      imgFullScreenName: null,
      imgFullScreenPath: null,
    };
  },
  created() {
    this.load(true);
    this.myInterval = setInterval(() => {
      this.load();
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.myInterval);
  },
  methods: {
    imgClick(item) {
      this.imgFullScreenName = item.label;
      this.imgFullScreenPath = this.toPath(item.path);

      this.$bvModal.show("img-full-screen");
    },
    clickUser(id) {
      this.selectedUser = id;
      this.load(true);
    },
    load(busyState = false) {
      if(busyState) {
        this.busy = true;
      }
      gestions.live(this.search, this.selectedUser).then((response) => {
        this.users = response.data.users;
        this.history = response.data.html;
        this.loaded = true;
        this.busy = false;
      });
    },
    toPath(path) {
      if (path.indexOf("/upload") == 0) {
        return this.$store.getters.url + path;
      }
      return this.$store.getters.url + "/uploadv2" + path;
    },
  },
};
</script>

<style lang="scss">
.carousel-caption h3 {
  color: inherit !important;
}
.carousel-item img:hover {
  cursor: pointer;
}
</style>